import {
  NextAction,
  Step,
  Answers,
  Measurements,
  CheckBoxGroupValue,
  NextHandler,
} from '@/programmes/components/FormV2/types'
import calculateBMI from '@/programmes/utils/calculateBMI'
import {
  EMAIL_QUESTION_ID,
  ETHNICITY_QUESTION_ID,
  HEIGHT_AND_WEIGHT_QUESTION_ID,
  WEIGHT_RELATED_ILLNESS_QUESTION_ID,
} from './preScreeningStepsV2'

export const heightAndWeightHandler = (
  currentStep: Step,
  answers: Answers
): NextAction => {
  if (
    currentStep.type === 'question' &&
    currentStep.inputType.component !== 'heightAndWeight'
  ) {
    return 'exit-action'
  }

  const { height, weight } = answers[currentStep.id] as Measurements
  const bmi = calculateBMI(height, weight)

  if (!bmi) {
    return 'exit-action'
  }

  if (bmi >= 23 && bmi <= 29.9) {
    return WEIGHT_RELATED_ILLNESS_QUESTION_ID
  }

  if (bmi >= 30) {
    return EMAIL_QUESTION_ID
  }

  return 'exit-action'
}

export const weightRelatedIllnessHandler: NextHandler = (
  currentStep: Step,
  answers: Answers
) => {
  if (currentStep.id !== WEIGHT_RELATED_ILLNESS_QUESTION_ID) {
    return 'exit-action'
  }

  const currentAnswer = answers[currentStep.id]
  const { height, weight } = answers[
    HEIGHT_AND_WEIGHT_QUESTION_ID
  ] as Measurements
  const bmi = calculateBMI(height, weight)
  const hasWeightIllness = (currentAnswer as CheckBoxGroupValue[]).every(
    (checkboxAnswer) =>
      (checkboxAnswer as CheckBoxGroupValue).value !== 'None of the above'
  )
  const highBMIWithNoWeightIllness =
    bmi && bmi >= 27.5 && bmi <= 29.9 && !hasWeightIllness
  const lowBMIWithWeightIllness =
    bmi && bmi >= 23 && bmi < 27 && hasWeightIllness

  if (highBMIWithNoWeightIllness || lowBMIWithWeightIllness) {
    return ETHNICITY_QUESTION_ID
  }

  if (hasWeightIllness) {
    return EMAIL_QUESTION_ID
  }

  return 'exit-action'
}
